import { atom } from "recoil";

export const WelcomeToastShown = atom({
  key: "WelcomeToastShown",
  default: false,
});
